/* H+O cart redirect guard (added 2026-10-06)

   UpCart opens its drawer on every add to cart, but some apps (e.g. Globo Product Options, when it
   doesn't recognize the theme's cart UI) then send the browser to /cart with a script redirect.
   Cancel script-initiated navigations to the cart page that happen shortly after an add to cart
   request. Clicking a cart link is user-initiated and is never blocked.

   Uses the Navigation API; browsers without it keep the old behaviour.
   The cart path comes from the script tag's data-cart-path attribute (routes.cart_url). */
(function () {
  try {
    if (!window.navigation || !window.PerformanceObserver) return;

    var script = document.currentScript;
    var CART_PATH = (script && script.dataset.cartPath) || '/cart';
    var WINDOW_MS = 10000;
    var lastAddAt = 0;

    new PerformanceObserver(function (list) {
      list.getEntries().forEach(function (entry) {
        if (entry.name.indexOf('/cart/add') !== -1) lastAddAt = Date.now();
      });
    }).observe({ type: 'resource', buffered: false });

    navigation.addEventListener('navigate', function (event) {
      try {
        if (!event.cancelable || event.userInitiated) return;
        if (event.navigationType !== 'push' && event.navigationType !== 'replace') return;
        if (Date.now() - lastAddAt > WINDOW_MS) return;
        var url = new URL(event.destination.url);
        if (url.origin !== location.origin || url.pathname !== CART_PATH) return;
        if (location.pathname === CART_PATH) return;
        event.preventDefault();
      } catch (e) { /* never let this break the page */ }
    });
  } catch (e) { /* never let this break the page */ }
})();
